import React from 'react';
import { Meteor } from 'meteor/meteor';

import {
  Col,
  BPanel,
  FormControl,
  FormGroup,
  ControlLabel,
  Checkbox,
  Well,
  Button
} from '@sketchpixy/rubix';
import { Reactive } from '../../common/Reactive.mixin.js';
var RingLoader = require('halogen/PulseLoader');

import { FlightsType } from '../../../collections/flights-type/flights-type';
import { Prices } from '../../../collections/flights-type/prices';

@Reactive({
	subscriptions: ["flights-type"]
})
export class SelectFlightComponent extends React.Component {

	constructor(props) {
		super(props);
    	this.state = {};

    	console.log("constructor");

	    props.ready.then(() => {
	    	console.log('state', props.selectedFlight);
	    	this.setState({ selectedFlight: props.selectedFlight });
	    });

    	this.onUpdate = props.onUpdate;
	    this.selectPeriod = props.selectPeriod;
	    this.selectPlace = props.selectPlace;
	    this.selectOptions = props.selectOptions;
      this.selectPromotions = props.selectPromotions;

	}

  renderSelectOptions(data, labelKey, notFoundText, needSelectedFlight = true) {
    if(!data || data.length == 0) {
      return (
        <option>{ notFoundText }</option>
      );
    }

    return data.map((item) => (
      <option value={item._id}>{ _.isFunction(item[labelKey]) ? item[labelKey]() : item[labelKey] }</option>
    ));
  }

 render() {

 	if(!this.props.isReady && !this.props.selectedFlight) {
  		return (
  			<RingLoader/>
  		);
  	}

   return (

    <Col sm={12}>
        <BPanel header="Choix du vol">

            <Col componentClass={ControlLabel} sm={8}>
              <FormGroup>
                <Col sm={3}>
                  Vol séléctionné
                </Col>
                <Col sm={9}>
                  <FormControl componentClass="select" type="select" onChange={this.onUpdate.bind(this)} ref="flight">
                  {_.includes(Meteor.user().roles, 'partner') &&
                    this.renderSelectOptions(FlightsType.find({}, { sort: { 'title': 1 } }).fetch(), 'title', '-', false)
                  }
                  {!_.includes(Meteor.user().roles, 'partner') &&
                    this.renderSelectOptions(FlightsType.find({"partnerId": null}, { sort: { 'title': 1 } }).fetch(), 'title', '-', false)
                  }
                  </FormControl>
                </Col>
              </FormGroup>

              <FormGroup>
                <Col sm={3}>
                  Période
                </Col>
                <Col sm={9}>
                  <FormControl componentClass="select" type="select" onChange={this.selectPeriod.bind(this)} ref="constraintPeriod">
                  		<option value="Semaine">SEMAINE</option>
                  		<option value="Libre date">LIBRE DATE</option>
                  </FormControl>
                </Col>
              </FormGroup>

              <FormGroup>
                <Col sm={3}>
                  Envol
                </Col>
                <Col sm={9}>
                  <FormControl componentClass="select" type="select" onChange={this.selectPlace.bind(this)} ref="constraintPlace">
                    { this.props.selectedFlight && this.renderSelectOptions([{_id: "anjou",name: "Sites d'envol Anjou"},{_id: "nantes",name: "Sites d'envol de Nantes"}], 'name', '-') }
                  </FormControl>
                </Col>
              </FormGroup>

              <FormGroup>
                <Col sm={3}>
                  Promotions séléctionnées
                </Col>
                <Col sm={6}>
                  <FormControl componentClass="select" type="select" onChange={this.selectPromotions.bind(this)} ref="promotions">
                    <option>-</option>
                    { this.props.selectedFlight && this.renderSelectOptions(this.props.selectedFlight.promotions(), "title", "Pas de promotion") }
                  </FormControl>
                </Col>
              </FormGroup>

            </Col>


          <Col sm={4}>
            <Well>
              <p><Button bsStyle="info">{this.props.selectedFlight && this.props.selectedFlight.constraintPassengerMin} minimum / {this.props.selectedFlight && this.props.selectedFlight.constraintPassengerMax} maximum</Button></p>
              {this.state.selectedFlight && this.state.selectedFlight.description.split("\n").map(function(item) {
                return (
                  <p>
                    {item}
                  </p>
                );
              })}
            </Well>
          </Col>

        </BPanel>
    </Col>
   );
 }


}



/** WEBPACK FOOTER **
 ** ./src/universal/components/reservations/components/component-flights-type-select.js
 **/